"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _components = require("components");

var _classnames2 = require("classnames");

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactRedux = require("react-redux");

var _topups = require("redux/modules/topups");

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _payments = require("redux/modules/payments");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TopupDialog = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    userSubscription: state.user.subscription,
    prices: state.payments.prices
  };
}, { buyTopup: _topups.buyTopup, getPrice: _payments.getPrice }, null, { withRef: true }), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(TopupDialog, _React$Component);

  function TopupDialog() {
    (0, _classCallCheck3.default)(this, TopupDialog);

    var _this = (0, _possibleConstructorReturn3.default)(this, (TopupDialog.__proto__ || (0, _getPrototypeOf2.default)(TopupDialog)).call(this));

    _this.state = {
      screen: "show-plans"
    };
    return _this;
  }

  (0, _createClass3.default)(TopupDialog, [{
    key: "handleCancelClick",
    value: function handleCancelClick() {
      this.props.onCloseNo();
    }
  }, {
    key: "forceClose",
    value: function forceClose(reason) {
      if (this.state.holdForPurchasing) return false;

      this.props.onCloseNo(reason);
    }
  }, {
    key: "onPlanBuyClick",
    value: function onPlanBuyClick(id) {
      this.setState({
        screen: "buy-plan",
        buyingPlan: id
      });
    }
  }, {
    key: "handlePayment",
    value: function handlePayment(props) {
      var _this2 = this;

      var _props = this.props,
          buyTopup = _props.buyTopup,
          prices = _props.prices,
          userSubscription = _props.userSubscription;
      var buyingPlan = this.state.buyingPlan;


      var promise = void 0;

      this.setState({
        holdForPurchasing: true
      });

      var _state = this.state,
          countryCode = _state.countryCode,
          vatNo = _state.vatNo;

      var price = buyingPlan.price;
      var priceInclusiveOfTax = _underscore2.default.findWhere(prices, { price: price, countryCode: countryCode, vatNo: vatNo }) || _underscore2.default.findWhere(prices, { priceExcludingTax: price, countryCode: countryCode, vatNo: vatNo });

      if (props.paymentMethodToken) {
        promise = buyTopup({
          planId: userSubscription.planId,
          addOnId: buyingPlan.id,
          amount: priceInclusiveOfTax.price,
          paymentMethodToken: props.paymentMethodToken
        });
      } else if (props.paymentMethodNonce) {
        promise = buyTopup((0, _extends3.default)({
          planId: userSubscription.planId,
          addOnId: buyingPlan.id,
          amount: priceInclusiveOfTax.price
        }, props));
      }

      if (promise) {
        return promise.then(function () {
          _this2.setState({
            successful: true
          });

          setTimeout(function () {
            return _this2.setState({
              holdForPurchasing: false
            });
          }, 3000);
        }).catch(function (error) {
          _this2.setState({
            holdForPurchasing: false
          });

          throw error;
        });
      }

      return _promise2.default.reject(new Error("`paymentMethodToken` is required to make a payment"));
    }
  }, {
    key: "renderPricingColumns",
    value: function renderPricingColumns() {
      var _this3 = this;

      var styles = require("./TopupDialog.scss");
      var userSubscription = this.props.userSubscription;

      var plans = userSubscription.refillPricePointMap;
      var titles = ["Regular", "Best Value", "Extra"];

      var onPlanBuyClick = function onPlanBuyClick(plan) {
        return _underscore2.default.partial(_this3.onPlanBuyClick.bind(_this3), plan);
      };

      return _react2.default.createElement(
        "ul",
        { className: styles.Plans },
        plans.map(function (plan, i) {
          return _react2.default.createElement(
            "li",
            { className: styles.Plan, key: plan.id },
            _react2.default.createElement(
              "div",
              { className: styles["Plan__details"] },
              _react2.default.createElement(
                "div",
                { className: styles["Plan__details-block"] },
                _react2.default.createElement(
                  "span",
                  { className: styles["Plan__details-block-value"] },
                  plan.points
                ),
                _react2.default.createElement(
                  "span",
                  { className: styles["Plan__details-block-label"] },
                  "Points"
                )
              )
            ),
            _react2.default.createElement(_components.Button, {
              primary: true,
              className: styles["Plan__button"],
              onClick: onPlanBuyClick(plan),
              label: "Add for $" + plan.price
            })
          );
        })
      );
    }
  }, {
    key: "onContinueClick",
    value: function onContinueClick(ev) {
      this.props.onCloseYes();
    }
  }, {
    key: "handleVATCheck",
    value: function handleVATCheck(countryCode, vatNo) {
      var getPrice = this.props.getPrice;
      var buyingPlan = this.state.buyingPlan;
      var price = buyingPlan.price;


      this.setState({ countryCode: countryCode, vatNo: vatNo });

      getPrice({
        transactionType: "refill-subscription",
        price: price,
        countryCode: countryCode,
        vatNo: vatNo
      });
    }
  }, {
    key: "renderFinalScreen",
    value: function renderFinalScreen() {
      var styles = require("./TopupDialog.scss");

      return _react2.default.createElement(
        "div",
        { className: styles.ThankyouBox },
        _react2.default.createElement(
          "p",
          { className: styles.ThankyouBox__message },
          "You're all set! You are now ready to use your extra points.",
          _react2.default.createElement("br", null),
          "Any unused points will carry over to the next subscription period."
        ),
        _react2.default.createElement(_components.Button, {
          primary: true,
          label: "Back to Browsing",
          onClick: this.onContinueClick.bind(this)
        })
      );
    }
  }, {
    key: "render",
    value: function render() {
      var styles = require("./TopupDialog.scss");

      var classes = (0, _classnames3.default)((0, _defineProperty3.default)({}, styles.TopupDialog, true));

      var _state2 = this.state,
          screen = _state2.screen,
          successful = _state2.successful;


      return _react2.default.createElement(
        _components.AppSideEffects,
        { scrollTop: 0 },
        _react2.default.createElement(
          "div",
          { className: styles["TopupBox"] },
          _react2.default.createElement(
            "div",
            { className: styles["TopupBox__inner"] },
            _react2.default.createElement(
              "div",
              { className: styles["TopupDialog__options"] },
              _react2.default.createElement(
                "div",
                { className: styles["Topup__banner"] },
                _react2.default.createElement(
                  "div",
                  { className: styles["Topup__banner-text"] },
                  successful ? _react2.default.createElement(
                    "h1",
                    { className: styles.TopupBox__success },
                    "Success!"
                  ) : _react2.default.createElement(
                    "h2",
                    { className: styles.TopupBox__title },
                    "Add more points now"
                  ),
                  !successful && _react2.default.createElement(
                    "p",
                    { className: styles.Topup__description },
                    "Instant refills at large discounts. Remaining points always bleed over to the next month."
                  )
                )
              ),
              screen == "show-plans" && _react2.default.createElement(
                "div",
                { className: styles.PricingBox },
                this.renderPricingColumns()
              ),
              screen == "buy-plan" && _react2.default.createElement(
                "div",
                { className: styles.PaymentBox },
                _react2.default.createElement(_components.PaymentWizard, {
                  onVATCheck: this.handleVATCheck.bind(this),
                  renderFinalScreen: this.renderFinalScreen.bind(this),
                  customerEditBehavior: "oneoff",
                  paymentBehavior: "oneoff",
                  showEmailSubscribe: false,
                  transactionType: "refill-subscription",
                  paymentCallback: this.handlePayment.bind(this)
                })
              )
            )
          )
        )
      );
    }
  }]);
  return TopupDialog;
}(_react2.default.Component)) || _class);
exports.default = TopupDialog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TopupDialog/TopupDialog.jsx
// module id = 2687
// module chunks = 0